<template>
  <v-container fluid>
    <v-layout align-center justify-center>
      <v-flex class="margin-custom-width-left" margin-custom-width-right>
        <v-alert v-for="(a, i) in this.alert" :key="i" :value="true" :color="a.alertType">
          <p v-html="a.alertText"></p>
        </v-alert>
        <br>
        <v-layout row wrap>
          <v-flex xs12 sm12 md5>
            <v-select v-model="calMonth" :items="monthOptions" label="Month"></v-select>
          </v-flex>
          <v-spacer></v-spacer>
          <v-flex xs12 sm12 md5>
            <v-select v-model="calYear" :items="yearOptions" label="Year"></v-select>
          </v-flex>
        </v-layout>
        <br />
        <v-tabs>
          <v-tab key="calendar">Calendar</v-tab>
          <v-tab-item key="calendar">
            <calendarview :events="sessions" />
          </v-tab-item>
          <v-tab key="table">Table</v-tab>
          <v-tab-item key="table">
            <tableview :events="sessions" />
          </v-tab-item>
        </v-tabs>
        <v-layout wrap>
          <v-btn @click="prev">
            <v-icon left>keyboard_arrow_left</v-icon>
            {{prevMonth}}
          </v-btn>
          <v-btn @click="next">
            {{nextMonth}}
            <v-icon right>keyboard_arrow_right</v-icon>
          </v-btn>
        </v-layout>
      </v-flex>
    </v-layout>
  </v-container>
</template>


<script>
import Vue from "vue";
import { mapGetters, mapActions } from "vuex";
import lodash from "lodash";
import store from "../store/store";
import moment from "moment";
import calendarview from "@/components/schedule-calendar-view";
import tableview from "@/components/schedule-table-view";

Vue.use(lodash);

export default {
  data: () => ({
    isLoaded: false,
    session: null
  }),

  components: {
    calendarview,
    tableview
  },

  mounted() {
    store.commit("set_date", moment()
      .startOf("month")
      .format("YYYY-MM-DD")
      .toString());
    this.getAlerts();
    if (this.$route.query.year) {
      store.commit("set_date", this.$route.query.year + "-01-01");
    }

    if (this.$route.query.startDate) {
      store.commit("set_date", this.$route.query.startDate);
    }

    this.showSchedule();
  },

  methods: {
    showSchedule() {
      let params = {
        sessionDate: new Date(this.date).toJSON(),
        type: this.$route.query.filter
          ? this.$route.query.filter.split(",")
          : ""
      };
      this.getSessions(params);
    },

    prev() {
      const newDate = moment(this.date)
        .subtract(1, "months");
      store.commit("set_date", newDate);
      this.showSchedule();
    },
    next() {
      const newDate = moment(this.date)
        .add(1, "months");
      store.commit("set_date", newDate);
      this.showSchedule();
    },

    moment,
    ...mapActions("session", {
      getSessions: "get"
    }),
    ...mapActions("alerts", { getAlerts: "get" }),
  },

  computed: {
    ...mapGetters(["http_error"]),
    ...mapGetters(["date"]),
    ...mapGetters("session", ["sessions"]),
    ...mapGetters("alerts", ["alert"]),
    prevMonth() {
      return moment(this.date)
        .subtract(1, "months")
        .format("MMMM");
    },
    nextMonth() {
      return moment(this.date)
        .add(1, "months")
        .format("MMMM");
    },
    monthOptions() {
      return Array.apply(null, Array(12)).map((item, index) => {
        let projected = moment()
          .month(index)
          .year(this.calYear)
          .startOf("month");
        return {
          text: projected.format("MMMM"),
          value: projected.format("MM")
        };
      });
    },
    yearOptions() {
      let years = [];
      let minYear = parseInt(2019);
      let maxYear = parseInt(2022);
      for (let year = minYear; year <= maxYear; year++) years.push(year);
      return years;
    },
    calMonth: {
      get() {
        if (moment(this.$store.state.date).month() === moment().month()) {
          return moment().format("MM");
        } else {
          return moment(this.$store.state.date).format("MM");
        }
      },
      set(value) {
        store.commit(
          "set_date",
          moment(value + "/01/" + this.calYear).format("YYYY-MM-DD")
        );
        this.showSchedule();
      }
    },
    calYear: {
      get() {
        if (moment(this.$store.state.date).year() === moment().year()) {
          return moment().year();
        } else {
          return moment(this.$store.state.date).year();
        }
      },
      set(value) {
        store.commit(
          "set_date",
          moment(this.calMonth + "/01/" + value).format("YYYY-MM-DD")
        );
        this.showSchedule();
      }
    }
  }
};
</script>